/**
 * Header Component
 * A reusable header component
 */
import Link from 'next/link'
import React from 'react'

import { CarrotLeft, MapQuestLogo } from '../icons'

interface HeaderProps {
  resetMFAFlow: () => void
  showBackButton?: boolean
}

export default function Header ({ resetMFAFlow, showBackButton = false }: HeaderProps): React.JSX.Element {
  return (
    <div className="relative max-w-[392px] w-full flex pt-5 items-center justify-center">
      {showBackButton && (
        <button className="absolute left-0 p-2 -m-2 cursor-pointer" data-testid="go-back" aria-label="Go back" onClick={resetMFAFlow}>
          <CarrotLeft width={10} />
        </button>
      )}

      <Link href="https://www.mapquest.com" rel="noreferrer" data-testid="mapquest-logo">
        <MapQuestLogo width={144} />
      </Link>
    </div>
  )
}
